import React from 'react'
import ZoneManagerAssignTrainer from '../../features/zoneManager/ZoneManagerAssignTrainer'

const ZoneManagerAssignTrainerPage = () => {
  return (
    <ZoneManagerAssignTrainer/>
  )
}

export default ZoneManagerAssignTrainerPage